import React from "react";
import PropTypes from "prop-types";
import { Select } from "../Forms";

function ThemeSwitcher({ defaultTheme = "light" }) {
  const themes = ["light", "dark", "purple"];
  const [theme, setTheme] = React.useState(defaultTheme);

  function changeTheme(e) {
    setTheme(e.target.value);
  }

  React.useEffect(() => {
    document.body.dataset.theme = theme;
  }, [theme]);

  return (
    <Select onChange={changeTheme}>
      {themes.map((theme) => (
        <option value={theme}>{theme}</option>
      ))}
    </Select>
  );
}
export default ThemeSwitcher;

ThemeSwitcher.propTypes = {
  defaultTheme: PropTypes.string,
};

ThemeSwitcher.defaultProps = {
  defaultTheme: "light",
};
